import FolderCard, { Props } from '../../../FolderCard';
import { getSubfoldersByParentId } from '../../selectors';
import { withMobileContext, WithMobileContextProps } from '@wix/da-react-context/pkg/MobileContext';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { setCurrentFolderId } from '../../actions';

export type StateProps = Pick<Props, 'hasSubfolders' | 'withLink'>;
export type DispatchProps = Pick<Props, 'onClick'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (state, ownProps: OwnProps & WithMobileContextProps) => {
  const subfolders = getSubfoldersByParentId(state, ownProps.folder.folderId);
  return {
    hasSubfolders: subfolders && subfolders.length > 0,
    withLink: false,
  };
};

const mapDispatchToProps: any = (dispatch, ownProps: OwnProps) => ({
  onClick: () => dispatch(setCurrentFolderId(ownProps.folder.folderId)),
});

export default withMobileContext(
  connectMediaStore(mapStateToProps, mapDispatchToProps)(FolderCard)
) as React.ComponentType<OwnProps>;
